import React, { useState, useEffect } from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import { Container, Row, Col, Form, Table, Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import bild from  '../softgewerk.png';
import {useNavigate} from "react-router-dom";

const ProvisionSmall = () => {
  const [Daten, setDaten] = useState([]);
  const [CL, setCL] = useState('');
  const [Vorgang, setVorgang] = useState('');
  const [DatenOriginal, setDatenOriginal] = useState([]);
  const [Closer, setCloser] = useState([]);
  const [CloserOriginal, setCloserOriginal] = useState([]);
  const [rechnungen, setrechnungen] = useState([]);
  const [angebote, setangebote] = useState([]);
  const [loading, setloading] = useState(false);
  const [modall, setModal] = useState(false);
  const [modalSaetze, setModalSaetze] = useState(false);
  const [modalcloser, setModalcloser] = useState(false);
  const [modalFilter, setmodalFilter] = useState(false);
  const [checkedFalse, setcheckedFalse] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [startDateFormatted, setStartDateFormatted] = useState('');
  const [endDateFormatted, setEndDateFormatted] = useState('');
  const [changedRechnungen, setChangedRechnungen] = useState([]);
  const [provisionssatz, setprovisionssatz] = useState(0.00);
  const [vorteilssatz, setvorteilssatz] = useState(0.00);
  const [filterCloser, setFilterCloser] = useState([]);
  const [filterAnzeigen, setfilterAnzeigen] = useState(1);
  const [gesamtAnzahl, setgesamtAnzahl] = useState(0);
  const [gesamtZahlbetrag, setgesamtZahlbetrag] = useState(0);
  const [gesamtProvisionCloserGesamt, setgesamtProvisionCloserGesamt] = useState(0);
  const [gesamtProvisionOffen, setgesamtProvisionOffen] = useState(0);
  const [gesamtProvisionAusbezahlt, setgesamtProvisionAusbezahlt] = useState(0);
  const navigate = useNavigate();


  const handleSwitchChange = (index) => {
    const updatedFilter = [...filterCloser];
    updatedFilter[index].checked = updatedFilter[index].checked === 1 ? 0 : 1;
    setFilterCloser(updatedFilter);
  };

  useEffect(() => {

    if (localStorage.getItem("loginData") == null) {
            
      navigate("/organizer/login");
 
      
    } else{
      var loginData = localStorage.getItem("loginData");
      var loginDataparsed = JSON.parse(loginData);
    
    }

    const currentDate = new Date();
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const formatDate = (date) => {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      const year = date.getFullYear();
      if (month < 10) month = `0${month}`;
      if (day < 10) day = `0${day}`;
      return `${year}-${month}-${day}`;
    };

    const formatGermanDate = (date) => {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      const year = date.getFullYear();
      if (month < 10) month = `0${month}`;
      if (day < 10) day = `0${day}`;
      return `${day}.${month}.${year}`;
    };



    const ladensaetze = async () => {
        try {
          const response = await axios.get('https://wartung.hoermann-haustechnik.de/provision/saetze.php', {
            params: {
              von: formatDate(firstDay),
              bis: formatGermanDate(lastDay)
            }
          });
          setprovisionssatz(response.data.provisionssatz);
          setvorteilssatz(response.data.vorteilssatz);
        } catch (error) {
          console.error('Fehler beim Laden der Daten:', error);
        }
      };

    setStartDate(formatDate(firstDay));
    setEndDate(formatDate(lastDay));
    setStartDateFormatted(formatGermanDate(firstDay));
    setEndDateFormatted(formatGermanDate(lastDay));
    ladensaetze();
  }, []);

  const handleStartDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    setStartDate(e.target.value);

    const formatGermanDate = (date) => {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      const year = date.getFullYear();
      if (month < 10) month = `0${month}`;
      if (day < 10) day = `0${day}`;
      return `${day}.${month}.${year}`;
    };

    setStartDateFormatted(formatGermanDate(selectedDate));
  };

  const handleEndDateChange = (e) => {
    const selectedDate = new Date(e.target.value);
    setEndDate(e.target.value);

    const formatGermanDate = (date) => {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      const year = date.getFullYear();
      if (month < 10) month = `0${month}`;
      if (day < 10) day = `0${day}`;
      return `${day}.${month}.${year}`;
    };

    setEndDateFormatted(formatGermanDate(selectedDate));
  };

  const laden = async () => {
    setloading(true);
    try {
      const response = await axios.get('https://wartung.hoermann-haustechnik.de/provision/provisionsmall.php', {
        params: {
          von: startDateFormatted,
          bis: endDateFormatted,
          status: checkedFalse
        }
      });
      setDaten(response.data.daten);
      setDatenOriginal(response.data.daten);
      setCloser(response.data.datenCloser);
      setCloserOriginal(response.data.datenCloser);

      setgesamtAnzahl(response.data.gesamtSummen.gesamtAnzahl);
      setgesamtZahlbetrag(response.data.gesamtSummen.gesamtZahlbetrag);
      setgesamtProvisionCloserGesamt(response.data.gesamtSummen.gesamtProvisionCloserGesamt);
      setgesamtProvisionOffen(response.data.gesamtSummen.gesamtProvisionOffen);
      setgesamtProvisionAusbezahlt(response.data.gesamtSummen.gesamtProvisionAusbezahlt);

      console.log(JSON.stringify(response.data.daten));
      var filter = [];
      const closerKuerzelSet = new Set(); // Set zum Vermeiden von Duplikaten
      for(let i = 0; i <= response.data.datenCloser.length - 1; i++){

        const closerKuerzell = response.data.datenCloser[i].closerKuerzel;

        // Überprüfen, ob closerKuerzel bereits existiert
        if (!closerKuerzelSet.has(closerKuerzell)) {
          closerKuerzelSet.add(closerKuerzell);

          const obj = {
            closerKuerzel: closerKuerzell,
            checked: 0,
          };

          filter.push(obj);
        }
      }

      setFilterCloser(filter);
      handleCloseFilter();
      setloading(false);
    } catch (error) {
      console.error('Fehler beim Laden der Daten:', error);
      setloading(false);
    }
  };

  const ladenn = async () => {
    const formData = new FormData();
    formData.append('von', startDateFormatted);
    formData.append('bis', endDateFormatted);
    if(filterAnzeigen){ 
      formData.append('state', "1");
    } else {
      formData.append('state', "0");
    }
   
    formData.append('daten', JSON.stringify(Daten));

    const response = await fetch('https://wartung.hoermann-haustechnik.de/provision/summierung.php', {
      method: 'POST',
      body: formData,
      headers: {
        // Kein Content-Type setzen, da fetch ihn bei FormData automatisch setzt
      },
    });

    var data = await response.json();
    
  
      setCloser(data.datenCloser);
      setCloserOriginal(data.datenCloser);

      setgesamtAnzahl(data.gesamtSummen.gesamtAnzahl);
      setgesamtZahlbetrag(data.gesamtSummen.gesamtZahlbetrag);
      setgesamtProvisionCloserGesamt(data.gesamtSummen.gesamtProvisionCloserGesamt);
      setgesamtProvisionOffen(data.gesamtSummen.gesamtProvisionOffen);
      setgesamtProvisionAusbezahlt(data.gesamtSummen.gesamtProvisionAusbezahlt);

      //console.log(JSON.stringify(response.data.daten));
   

    
  
    setModalcloser(true);
  };

  const handleCloseSpalten = async () => {
    setModal(false);
  }

  const handleCloseSpaltenWerte = async () => {

    try {
        var jsonrechnungen = JSON.stringify(changedRechnungen);
        const response = await axios.get('https://wartung.hoermann-haustechnik.de/provision/provisionergaenzensmall.php', {
          params: {
            rechnungen: jsonrechnungen
          }
        });
      } catch (error) {
        console.error('Fehler beim Laden der Daten:', error);
        setloading(false);
      }
    
    setModal(false);
    //laden();
    console.log('Geänderte Rechnungen:', changedRechnungen);
    
  };

  const handleCloseSpaltenWertee = () => {
    
    setModalcloser(false);
    
  };

  const handleCloseFilter =  () => {

    
    //Für Anzeige Provision Gesamt Summiert
    const hasCheckedItems = filterCloser.some(item => item.checked === 1);
    if(hasCheckedItems){
    const filteredData = CloserOriginal.filter((item) => {
      // Überprüfen, ob das closerKuerzel im filterCloser existiert und checked auf 1 gesetzt ist
      const filterMatch = filterCloser.find(
        (filterItem) =>
          filterItem.closerKuerzel === item.closerKuerzel && filterItem.checked === 1
      );
      return !!filterMatch; // Nur Elemente aufnehmen, bei denen es eine Übereinstimmung gibt
    });
  
    setCloser(filteredData);
    setgesamtAnzahl(filteredData.reduce((sum, item) => sum + item.anzahl, 0));
    setgesamtZahlbetrag(filteredData.reduce((sum, item) => sum + item.aufsummierterZahlbetrag, 0));
    setgesamtProvisionCloserGesamt(filteredData.reduce((sum, item) => sum + item.aufsummierteProvisionCloserGesamt, 0));
    setgesamtProvisionOffen(filteredData.reduce((sum, item) => sum + item.aufsummierteProvisionOffen, 0));
    setgesamtProvisionAusbezahlt(filteredData.reduce((sum, item) => sum + item.aufsummierteProvisionAusbezahlt, 0));
  } else {
    setCloser(CloserOriginal);
    setgesamtAnzahl(CloserOriginal.reduce((sum, item) => sum + item.anzahl, 0));
    setgesamtZahlbetrag(CloserOriginal.reduce((sum, item) => sum + item.aufsummierterZahlbetrag, 0));
    setgesamtProvisionCloserGesamt(CloserOriginal.reduce((sum, item) => sum + item.aufsummierteProvisionCloserGesamt, 0));
    setgesamtProvisionOffen(CloserOriginal.reduce((sum, item) => sum + item.aufsummierteProvisionOffen, 0));
    setgesamtProvisionAusbezahlt(CloserOriginal.reduce((sum, item) => sum + item.aufsummierteProvisionAusbezahlt, 0));
  }

  //Tabellenanzeige der Closer
  //erste Konstellation einen oder mehrere Closer ausgewählt und keine offenen anzeigen
  if(hasCheckedItems && checkedFalse === false){
    const filteredData = DatenOriginal.filter((item) => {
      // Überprüfen, ob das closerKuerzel im filterCloser existiert und checked auf 1 gesetzt ist
      const filterMatch = filterCloser.find(
        (filterItem) =>
          filterItem.closerKuerzel === item.Closer && filterItem.checked === 1
      );
      return !!filterMatch; // Nur Elemente aufnehmen, bei denen es eine Übereinstimmung gibt
    });
  
    setDaten(filteredData);
  }


  //zweite Konstellation einen oder mehrere Closer ausgewählt und nur offene anzeigen
  else if(hasCheckedItems && checkedFalse === true){
    const filteredData = DatenOriginal.filter((item) => {
      // Überprüfen, ob das closerKuerzel im filterCloser existiert und checked auf 1 gesetzt ist
      const filterMatch = filterCloser.find(
        (filterItem) =>
          filterItem.closerKuerzel === item.Closer && filterItem.checked === 1 && item.provisionOffen > 0 && item.rechnungen.length > 0 && item.rechnungen.some(rechnung => rechnung.ZahlBetrag > 0 && rechnung.BemerkZahlEingang.trim() === '')
      );
      return !!filterMatch; // Nur Elemente aufnehmen, bei denen es eine Übereinstimmung gibt
    });
  
    setDaten(filteredData);

  }


  //dritte Konstellation keinen Closer ausgewählt und keine offenen anzeigen
  else if(!hasCheckedItems && checkedFalse === false){
 
  
    setDaten(DatenOriginal);

  }

  //vierte Konstellation keinen Closer ausgewählt und nur offene anzeigen
  else if(!hasCheckedItems && checkedFalse === true){
 
    const filteredData = DatenOriginal.filter(
      (item) => item.provisionOffen > 0 && item.rechnungen.length > 0 && item.rechnungen.some(rechnung => rechnung.ZahlBetrag > 0 && rechnung.BemerkZahlEingang.trim() === '') 
    );
  
    setDaten(filteredData);

  }

  else {
    setDaten(DatenOriginal);
  }

    setmodalFilter(false);
    
  };

  const notSave = async () => {

    setModal(false);

  }


  const handleCloseSpaltenWerteee = async () => {
    
    try {
        const response = await axios.get('https://wartung.hoermann-haustechnik.de/provision/provisionsaetzeaktualisieren.php', {
          params: {
            provisionssatz: provisionssatz,
            vorteilssatz: vorteilssatz
          }
        });
      } catch (error) {
        console.error('Fehler beim Laden der Daten:', error);
      }

      laden();
    setModalSaetze(false);
   
    
  };





  const modaldaten = (index) => {
    if (Daten[index] && Daten[index].rechnungen) {
      setrechnungen(Daten[index].rechnungen);
      setangebote(Daten[index].angebote);
      setCL(Daten[index].Closer);
      setVorgang(Daten[index].ProjNr);
      setModal(true);
    } else {
      console.error(`Rechnungen für den Index ${index} sind nicht verfügbar`);
    }
  };


  const handleInputChange = (indexx, e) => {
    const newValue = e.target.value;
    const rechnungNr = rechnungen[indexx].RechnungsNr;
    const provision = rechnungen[indexx].provision;

    // Check if the rechnungNr is already in changedRechnungen
    const existingChangeIndex = changedRechnungen.findIndex(item => item.RechnungsNr === rechnungNr);

    if (existingChangeIndex !== -1) {
      // Update the existing entry
      const updatedChanges = [...changedRechnungen];
      updatedChanges[existingChangeIndex].text = newValue;
      setChangedRechnungen(updatedChanges);
    } else {
      // Add a new entry
      setChangedRechnungen([...changedRechnungen, { RechnungsNr: rechnungNr, text: newValue, provision: provision, Closer: CL, Projekt: Vorgang}]);
    }

    // Also update the original rechnungen array for the input value to reflect
    const updatedRechnungen = [...rechnungen];
    updatedRechnungen[indexx].BemerkZahlEingang = newValue;
    setrechnungen(updatedRechnungen);
};

const getInputValue = (indexx) => {
    const rechnungNr = rechnungen[indexx].RechnungsNr;
    const changedItem = changedRechnungen.find(item => item.RechnungsNr === rechnungNr);
    return changedItem ? changedItem.text : rechnungen[indexx].BemerkZahlEingang;
};

const handleShowProzent = async () => {
    try {
        const response = await axios.get('https://wartung.hoermann-haustechnik.de/provision/saetze.php', {

        });
        setprovisionssatz(response.data.provisionssatz);
        setvorteilssatz(response.data.vorteilssatz);
        setModalSaetze(true);
      } catch (error) {
        console.error('Fehler beim Laden der Daten:', error);
      }
};


const setanzeigen = async (index) => {

  const updatedD = [...Daten];
  updatedD[index].anzeigen =  updatedD[index].anzeigen === 1 ? 0 : 1;
  setDaten(updatedD);

  try {
    const response = await axios.get('https://wartung.hoermann-haustechnik.de/provision/anzeigen.php', {
      params: {
        projnr: updatedD[index].ProjNr,
        anzeigen:  updatedD[index].anzeigen === 1 ? 0 : 1

      }
    });
  } catch (error) {
    console.error('Fehler beim Laden der Daten:', error);
  }
};

const saveexcel = async () => {
  setloading(true);
  try {
    const formData = new FormData();
    formData.append('von', startDateFormatted);
    formData.append('bis', endDateFormatted);
    if(filterAnzeigen){ 
      formData.append('state', "1");
    } else {
      formData.append('state', "0");
    }
    formData.append('daten', JSON.stringify(Daten));

    const response = await fetch('https://wartung.hoermann-haustechnik.de/provision/export.php', {
      method: 'POST',
      body: formData,
      headers: {
        // Kein Content-Type setzen, da fetch ihn bei FormData automatisch setzt
      },
    });

        // Erstellen eines <a>-Tags
        const a = document.createElement('a');
        a.href = 'https://wartung.hoermann-haustechnik.de/provision/export/Provisionstool.xlsx';
        a.download = 'Provisionstool.xlsx'; // Fallback-Filename
        a.style.display = 'none';
    
        // Füge den <a>-Tag zum DOM hinzu
        document.body.appendChild(a);
    
        // Simuliere einen Klick auf den <a>-Tag
        a.click();
    
        // Entferne den <a>-Tag nach dem Download
        document.body.removeChild(a);

    setloading(false);
  } catch (error) {
    console.error('Fehler beim Laden der Daten:', error);
    setloading(false);
  }

}

  return (
    <Container fluid >
      <Container>
        <Row>
<Col xs={7} md={4} lg={3} sm={7}>
  <img className='img-fluid' src={bild}/> 
  </Col>


</Row>
</Container>

<Container>
        <Row>

 <Col onClick={saveexcel} xs={{ span: 2, offset: 9}} className="text-center p-3 mb-2">
 <i class="bi bi-file-earmark-excel"></i> Excel Download (aktuelle, gefilterte Ansicht)
 </Col>

</Row>
</Container>
<Container>

      <Row className="mt-3">
       
        <Col md={6}>
          <Form.Group controlId="formStartDate">
            <Form.Label>Auftragsdatum Projekte von</Form.Label>
            <Form.Control
              type="date"
              value={startDate}
              onChange={handleStartDateChange}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="formEndDate">
            <Form.Label>Auftragsdatum Projekte bis</Form.Label>
            <Form.Control
              type="date"
              value={endDate}
              onChange={handleEndDateChange}
            />
          </Form.Group>
        </Col>
      </Row>
      <br />
      <div className="row">
        <div className="col-12 d-flex justify-content-center">
          <button onClick={() => laden()} style={{ width: '20%' }} type="button" className="btn btn-light">
            <i className="bi bi-search"> (2x Klicken) </i>
          </button>
        </div>
      </div>

      <br /><br />

 

<div className="row">
  <div className="col-12 d-flex justify-content-center">
    <button onClick={() => setmodalFilter(true)} style={{ width: '20%' }} type="button" className="btn btn-light">
    <i class="bi bi-funnel"></i>
    </button>
  </div>
</div>

<br /><br />

<div className="row">
        <div className="col-12 d-flex justify-content-center">
          <button onClick={() => ladenn()} style={{ width: '20%' }} type="button" className="btn btn-light">
          Monatliche Übersicht pro Closer 
          </button>
        </div>
      </div>
      </Container>

      <br /><br />
      <Container fluid >
      {loading && (
        <Row>
          <Col xs={12} className="text-center">
            <Spinner animation="border" variant="primary" />
          </Col>
        </Row>
      )}
      <br /><br />
    
      <Row>
        <Col xs={12}>
          <Table striped responsive bordered hover>
            <thead>
              <tr>
              <th>Spalte anzeigen?</th>
                <th>Closer Kürzel</th>
                <th>Projektnummer</th>
                <th>Projektbezeichnung</th>
                <th>Abteilung</th>
                <th>Auftragseingang</th>
                <th>Zahlbetrag</th>
                <th>Provision Closer Gesamt</th>
                <th>Provision Offen</th>
                <th>Provision ausbezahlt</th>
                <th>Auszahlungsmonat</th>
              </tr>
            </thead>
            <tbody>
            {Daten.map((v, index) => (
  ((v.anzeigen === 1 && filterAnzeigen === 1) || 
  (v.anzeigen === 0 && filterAnzeigen === 0)) ? (
    <tr key={index}>
      <td> 
        <Form.Check
          type="switch"
          id={`custom-switchhhhj-${index}`}
          checked={v.anzeigen === 1}
          onChange={() => setanzeigen(index)}
          className={`custom-switch ${v.anzeigen ? 'custom-switch-checked' : ''}`}
        />
      </td>
      <td onClick={() => modaldaten(index)}>{v.Closer} <br></br> Closer: {v.Setter}</td>
      <td onClick={() => modaldaten(index)}>{v.ProjNr}</td>
      <td onClick={() => modaldaten(index)}>{v.ProjBezeichnung}</td>
      <td onClick={() => modaldaten(index)}>{v.Abteilung}</td>
      <td onClick={() => modaldaten(index)}>{v.Auftragseingang}</td>
      <td onClick={() => modaldaten(index)}>{v.zahlbetrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
      <td onClick={() => modaldaten(index)}>{v.provisionCloserGesamt.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
      <td onClick={() => modaldaten(index)} style={{ color: 'red' }}>
        {v.provisionOffen.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
      </td>
      <td onClick={() => modaldaten(index)} style={{ color: 'green' }}>
        {v.provisionAusbezahlt.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}
      </td>
      <td onClick={() => modaldaten(index)}>{v.monat}</td>
    </tr>
  ) : null
))}

            </tbody>
          </Table>
        </Col>
      </Row>
      </Container>

      <Modal backdrop="static" show={modall} onHide={handleCloseSpalten} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Rechnungen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
<p>Beim Speichern wird die jeweilige Provision direkt in die Stundenerfassung des Mitarbeiters geschrieben, dazu den Monat bitte NUR in der ausgeschriebenen Form eintragen mit Jahr zum Beispiel: <br></br>          <ul>
            <li>Januar 2025</li>
            <li>Februar 2025</li>
            <li>März 2025</li>
            <li>April 2025</li>
            <li>Mai 2025</li>
            <li>Juni 2025</li>
            <li>Juli 2025</li>
            <li>August 2025</li>
            <li>September 2025</li>
            <li>Oktober 2025</li>
            <li>November 2025</li>
            <li>Dezember 2025</li>
          </ul>
        </p>
        <br></br>
        <Row>
          <Col xs={12}>
            <Table striped responsive bordered hover>
              <thead>
                <tr>
                  <th>Rechnungsnummer</th>
                  <th>Rechnungsart</th>
                  <th>Datum 1. ZE</th>
                  <th>Zahlungseingang</th>
                  <th>Closer Provision</th>
                  <th>Monat Auszahlung Provision</th>
                </tr>
              </thead>
              <tbody>
                {rechnungen.map((vv, indexx) => (
                  <tr key={indexx}>
                    <td>{vv.RechnungsNr}</td>
                    <td>{vv.RECHTYP}</td>
                    <td>{vv.ZahlDatum}</td>
                    <td>{vv.ZahlBetrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
                    <td>{vv.provision.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
                    <td>
                      <Form.Control
                        type="text"
                        value={getInputValue(indexx)}
                        onChange={(e) => handleInputChange(indexx, e)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
          <br></br><br></br>
          <span>Erstellte Angebote zum Projekt mit Status eingegangen:</span>
          <br></br><br></br>
          <Col xs={12}>
            <Table striped responsive bordered hover>
              <thead>
                <tr>
                  <th>Angebotsnummer</th>
                  <th>Betreff</th>
                  <th>Nettobetrag</th>
                </tr>
              </thead>
              <tbody>
                {angebote.map((vv, indexx) => (
                  <tr key={indexx}>
                    <td>{vv.ANGEBOTSNR}</td>
                    <td>{vv.BETREFF}</td>
                    <td>{vv.Netto.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={handleCloseSpaltenWerte}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>


    <Modal   backdrop="static" show={modalcloser} onHide={handleCloseSpaltenWertee}  size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Übersicht Summierung {startDateFormatted} bis {endDateFormatted}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Table striped responsive bordered hover>
              <thead>
                <tr>
                  <th>Kürzel</th>
                  <th>Anzahl</th>
                  <th>Monat</th>
                  <th>Summierung Zahlungseingang</th>
                  <th>Summierung Provision Gesamt </th>
                  <th>Summierung Provision Offen</th>
                  <th>Summierung Provision Ausbezahlt</th>
                </tr>
              </thead>
              <tbody>
                {Closer.map((vvv, indexxx) => (
                  <tr key={indexxx}>
                    <td>{vvv.closerKuerzel}</td>
                    <td>{vvv.anzahl}</td>
                    <td>{vvv.Monat}</td>
                    <td>{vvv.aufsummierterZahlbetrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
                    <td>{vvv.aufsummierteProvisionCloserGesamt.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
                    <td style={{ color: 'red' }}>{vvv.aufsummierteProvisionOffen.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
                    <td style={{ color: 'green' }}>{vvv.aufsummierteProvisionAusbezahlt.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>

                  </tr>
                ))}
              </tbody>
            </Table>
            <br></br>
            <p>Gesamtwerte</p>
            <br></br>
            <Table striped responsive bordered hover>
              <tr>
                <td><b>Gesamt - Anzahl</b></td>
                <td><b>Gesamt - Zahlungseingang</b></td>
                <td><b>Gesamt - Provision Closer</b></td>
                <td><b>Gesamt - Provision Offen</b></td>
                <td><b>Gesamt - Provision ausbezahlt</b></td>
              </tr>
             <tr>
              <td>{gesamtAnzahl}</td>
              <td>{gesamtZahlbetrag.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
              <td>{gesamtProvisionCloserGesamt.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
              <td>{gesamtProvisionOffen.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
              <td>{gesamtProvisionAusbezahlt.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })}</td>
             </tr>
            </Table>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={handleCloseSpaltenWertee}>
          Schließen
        </Button>
      </Modal.Footer>
    </Modal>

    
  


    <Modal  backdrop="static" show={modalFilter} onHide={handleCloseFilter} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Filter für ausgewählten Zeitraum setzen</Modal.Title>
      </Modal.Header>
      <Modal.Body>

      <div className='row'>
                    <div className='col-12'>

                    <Form.Check
                            type="switch"
                            id={`custom`}
                            checked={filterAnzeigen}
                            label={filterAnzeigen ? 'Angezeigt werden jetzt: Aktive  Projekte (zur Auszahlung berücksichtigt)' : 'Angezeigt werden jetzt: Ausgeschlossene Projekte  (keine Auszahlung'}
                            onChange={() => setfilterAnzeigen(filterAnzeigen === 1 ? 0 : 1)}
                            className={`custom-switch ${filterAnzeigen ? 'custom-switch-checked' : ''}`}
                          />

                    </div>
                    </div>
                    <br></br>

      <div className='row'>
                    <div className='col-12'>

                    <Form.Check
                            type="switch"
                            id={`custom-switchhh`}
                            checked={checkedFalse}
                            label={checkedFalse ? 'Angezeigt werden jetzt: Offene Provisionen zur Auszahlung bereit' : 'Angezeigt werden jetzt: Alle Projekte'}
                            onChange={() => setcheckedFalse(!checkedFalse)}
                            className={`custom-switch ${checkedFalse ? 'custom-switch-checked' : ''}`}
                          />

                    </div>
                    </div>
                    <br></br>

      {filterCloser.length > 0 && filterCloser ? (<div>Filterbare Closer: <br></br><br></br></div>) : null}
      {filterCloser.length > 0 && filterCloser ? filterCloser.map((data, index) => (
                <div key={index}>
                  <div className='row'>
                    <div className='col-12'>

                    <Form.Check
                            type="switch"
                            id={`custom-switch-${index}`}
                            checked={data.checked}
                            label={data.closerKuerzel}
                            onChange={() => handleSwitchChange(index)}
                            className={`custom-switch ${data.checked ? 'custom-switch-checked' : ''}`}
                          />

                    </div>
                    </div>
                    </div>
      )) : null}
      </Modal.Body>
      <Modal.Footer> 
        <Button variant="light" onClick={handleCloseFilter}>
          Speichern
        </Button>
      </Modal.Footer>
    </Modal>

    </Container>
  );
};

export default ProvisionSmall;
